/**
 * Metaobject Localization Handler
 * 
 * Handles language switching for metaobject pages (avis de deces, complexes, cimetieres)
 * Preserves the metaobject URL structure when switching languages
 */


if (!customElements.get('localization-form')) {
  customElements.define('localization-form', class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      const clickedItem = event.currentTarget;
      
      // Get the selected locale/country code
      const selectedValue = clickedItem.dataset.value;
      this.elements.input.value = selectedValue;
      
      // Check if we're on a metaobject page
      const isMetaobjectPage = this.isMetaobjectPage();
      
      if (isMetaobjectPage) {
        // Handle metaobject URL transformation
        const newUrl = this.getMetaobjectLocalizedUrl(selectedValue);
        if (newUrl) {
          window.location.href = newUrl;
          return;
        }
      }
      
      // Default behavior: submit the form
      if (form) form.submit();
    }

    /**
     * Check if current page is a metaobject page
     */
    isMetaobjectPage() {
      const path = window.location.pathname;
      
      // Check for metaobject patterns
      const metaobjectPatterns = [
        /\/pages\/avis-de-deces\//,
        /\/pages\/complexes-funeraires\//,
        /\/pages\/cimetieres-et-mausolees\//
      ];
      
      return metaobjectPatterns.some(pattern => pattern.test(path));
    }

    /**
     * Get the localized URL for a metaobject
     */
    getMetaobjectLocalizedUrl(localeCode) {
      const path = window.location.pathname;
      const isFrench = localeCode === 'fr';
      const isEnglish = localeCode === 'en';
      
      // Extract the metaobject handle (last part of URL)
      const pathParts = path.split('/').filter(Boolean);
      const handle = pathParts[pathParts.length - 1];
      
      // Determine metaobject type
      let metaobjectType = null;
      if (path.includes('avis-de-deces')) {
        metaobjectType = 'avis-de-deces';
      } else if (path.includes('complexes-funeraires')) {
        metaobjectType = 'complexes-funeraires';
      } else if (path.includes('cimetieres-et-mausolees')) {
        metaobjectType = 'cimetieres-et-mausolees';
      }
      
      if (!metaobjectType || !handle) return null;
      
      // Build the new URL
      let newUrl = '';
      
      if (isEnglish) {
        // Switch to English
        newUrl = `/en/pages/${metaobjectType}/${handle}`;
      } else if (isFrench) {
        // Switch to French (remove /en/ prefix)
        newUrl = `/pages/${metaobjectType}/${handle}`;
      }
      
      return newUrl;
    }

    /**
     * Open the selector panel
     */
    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  });
}
